import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';
import WebsiteComponent from './components/websiteComponent';

const CreditTransferInfoWebsite = ({
  onChange,
  initialValue,
  formatMessage,
}) => (
  <WebsiteComponent
    name="Credit-Transfer-Info"
    value={initialValue.value}
    onChange={onChange}
    stylesName="transfer-website-container"
    subheading={formatMessage(messages.creditTransferInfoWebsiteLabel)}
    placeholder={formatMessage(messages.creditTransferInfoWebsitePlaceholder)}
    showError={initialValue.showError}
  />
);

CreditTransferInfoWebsite.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};

export default CreditTransferInfoWebsite;
